export default {
  CONNECTED: 1,
  PENDING: 2,
  FAILED: 3
};
